import { getTableMetaHelper, Skeleton } from '@round/ui-kit';
import { CellContext } from '@tanstack/react-table';
import { CampaignsTableMeta } from 'Modules/Plans/Campaigns/types';
import CostCell from 'Modules/Plans/components/CostCell/CostCell';
import { CampaignTableRow } from '../types';

const getTableMeta = getTableMetaHelper<CampaignsTableMeta>();

const CampaignCostCell = <T extends CampaignTableRow>({ table, row: { original } }: CellContext<T, unknown>) => {
    const { isLoading } = getTableMeta(table);

    if (isLoading) {
        return <Skeleton />;
    }

    return <CostCell isReadonly cost={original.cost ?? null} currency={original.currency ?? null} />;
};

export default CampaignCostCell;
